<ng-container>
  <div class="formControl mt">
    <pr-input-radio
      formControlName="savingsRate"
      direction="column"
      [isDefault]="false"
      [options]="options"
      columns="1"
    >
    </pr-input-radio>
  </div>
</ng-container>
